import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getImageInfo } from "../redux/getTools/imageAction";
import { getTitleInfo } from "../redux/getTitle/titleAction";
import { BiSolidRightArrow } from "react-icons/bi";
import { MdOutlineTimer } from "react-icons/md";
import quickLogo from "../assets/quicky.png";
import "./Access.css";

const AccessImg = ({ readTime }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qValue = queryParams.get("q");
  const [imageUrl, setImageUrl] = useState("");
  const [titleUrl, setTitleUrl] = useState("");
  const [message, setMessage] = useState("");
  const [duration, setDuration] = useState("");
  const dispatch = useDispatch();
  console.log(qValue);
  console.log(imageUrl);

  useEffect(() => {
    // Fetch the image data using getImageInfo action
    dispatch(getImageInfo(qValue)).then((response) => {
      console.log(response);
      if (response && response.status === "success") {
        // Update the imageUrl state with the data from the response
        setImageUrl(response.data);
        setTitleUrl(response.title);
        setMessage(response.message);
        setDuration(response.duration);
      }
    });

    // Fetch the title data using getTitleInfo action
    // dispatch(getTitleInfo(qValue)).then((response) => {
    //   if (response && response.status === "success") {
    //     // Update the titleUrl state with the data from the response
    //     setTitleUrl(response.title);
    //   }
    // });
  }, [qValue, dispatch]);

  return (
    <div className="lg:mt-20">
      <div className="main-div">
        <div className="quickLogo">
          <img src={quickLogo} alt="logo" />
        </div>
        <div className="quick-guide">
          <div className="quick-label">
            <BiSolidRightArrow />
          </div>
          <h2 className="quick-text">QUICK GUIDE BY LIFEBANK</h2>
        </div>
        <div className="prevent-div">
          <p className="prevent-text">{titleUrl}</p>
          <div className="page-p"></div>
        </div>
        {duration && (
          <div className="minutes-div">
            <div className="minutes-label">
              <MdOutlineTimer />
            </div>
            <p className="minutes-text">{duration}</p>
          </div>
        )}
      </div>
      {/* Display the image if imageUrl is available */}

      {imageUrl && (
        <img
          src={`https://${imageUrl}`}
          className="lg:w-full object-contain"
          alt={message}
        />
      )}
    </div>
  );
};

export default AccessImg;
